import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_00.jpg";

const data: ReplicaItemType = {
  id: "advanced-potion-making-v3-diy-cover",
  name: "DIY Cover Advanced Potion-Making v3 - Prince's Copy",
  nameFormatted: {
    primary: "DIY Cover",
    secondary: "Advanced Potion-Making v3",
    tertiary: "Prince's Copy",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
